module.exports = __webpack_public_path__ + "img/fortnightly-deliveries-selected.d24ee0d8.png";